/** Chromosomal location of a psittacine colour locus. */
export var LocusChromosome;
(function (LocusChromosome) {
    LocusChromosome["AUTOSOME"] = "AUTOSOME";
    /** Z chromosome — hemizygous in females (ZW). */
    LocusChromosome["Z"] = "Z";
    LocusChromosome["W"] = "W";
})(LocusChromosome || (LocusChromosome = {}));
/**
 * Inheritance modes aligned with Ornitho-Genetics / Genetic Calculator notation.
 * @see https://www.gencalc.com (re, se, do, in, cd)
 */
export var InheritanceMode;
(function (InheritanceMode) {
    /** Autosomal recessive (gencalc: re) — homozygous mutant required for visual. */
    InheritanceMode["AUTOSOMAL_RECESSIVE"] = "AUTOSOMAL_RECESSIVE";
    /** Autosomal dominant (gencalc: do) — one mutant allele sufficient. */
    InheritanceMode["AUTOSOMAL_DOMINANT"] = "AUTOSOMAL_DOMINANT";
    /** Autosomal incomplete dominant (gencalc: in) — SF vs DF phenotypes. */
    InheritanceMode["AUTOSOMAL_INCOMPLETE_DOMINANT"] = "AUTOSOMAL_INCOMPLETE_DOMINANT";
    /** Co-dominant / multi-allele series (gencalc: cd). */
    InheritanceMode["CODOMINANT"] = "CODOMINANT";
    /** Sex-linked recessive (gencalc: se) — locus on Z; females hemizygous. */
    InheritanceMode["SEX_LINKED_RECESSIVE"] = "SEX_LINKED_RECESSIVE";
    /** Sex-linked dominant on Z. */
    InheritanceMode["SEX_LINKED_DOMINANT"] = "SEX_LINKED_DOMINANT";
    /** Quantitative / polygenic — prediction provides guidance only. */
    InheritanceMode["POLYGENIC"] = "POLYGENIC";
})(InheritanceMode || (InheritanceMode = {}));
export var GenotypeSource;
(function (GenotypeSource) {
    GenotypeSource["MANUAL"] = "MANUAL";
    GenotypeSource["INFERRED"] = "INFERRED";
    GenotypeSource["BANDING"] = "BANDING";
    GenotypeSource["PREDICTION"] = "PREDICTION";
    GenotypeSource["IMPORT"] = "IMPORT";
})(GenotypeSource || (GenotypeSource = {}));
/** When a breeding prediction snapshot was captured. */
export var PredictionTrigger;
(function (PredictionTrigger) {
    PredictionTrigger["HATCH"] = "HATCH";
    PredictionTrigger["BANDED"] = "BANDED";
    PredictionTrigger["MANUAL"] = "MANUAL";
})(PredictionTrigger || (PredictionTrigger = {}));
export var ZygosityLabel;
(function (ZygosityLabel) {
    ZygosityLabel["WILD_TYPE"] = "WILD_TYPE";
    ZygosityLabel["SPLIT"] = "SPLIT";
    ZygosityLabel["SINGLE_FACTOR"] = "SINGLE_FACTOR";
    ZygosityLabel["DOUBLE_FACTOR"] = "DOUBLE_FACTOR";
    ZygosityLabel["VISUAL"] = "VISUAL";
    ZygosityLabel["HEMIZYGOUS"] = "HEMIZYGOUS";
})(ZygosityLabel || (ZygosityLabel = {}));
